module.exports = __webpack_public_path__ + "img/content-image.1c085ba5.png";